import './EmptyResults.scss'

import React from 'react'
import { useSearchParams } from 'react-router-dom'

import { ContactUs } from 'hb4e-ui-core-ui'

const EmptyResults = () => {
  const [searchParams] = useSearchParams()
  const searchTerm = searchParams.get('term')

  return (
    <div className="empty-results">
      <div className="empty-results__container">
        <div className="empty-results__results-count">0 Results</div>
        <div className="empty-results__results">
          <p className="empty-results__no-results">
            Sorry, we did not find any results for “{searchTerm}” in any of your lists. Please try a different search
            term and read our helpful search tips.
          </p>

          <p className="empty-results__tips">Helpful Search Tips:</p>
          <ul className="empty-results__tips-list">
            <li className="empty-results__tips-list-item">Check the spelling</li>
            <li className="empty-results__tips-list-item">Use English terms</li>
            <li className="empty-results__tips-list-item">Type product numbers in this format: 000000-AAA-AAA</li>
            <li className="empty-results__tips-list-item">
              Try searching the entire site to add a product to your coursepacks
            </li>
          </ul>
        </div>

        <div className="empty-results__contact-us">
          <ContactUs>
            If you’d like assistance, contact us. Customer Service is available 24 hours a day, 7 days a week.
          </ContactUs>
        </div>
      </div>
    </div>
  )
}

export default EmptyResults
